"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMinimumNoticeTimeBusyDays = exports.getConfiguredAvailabilityByDate = exports.getConfiguredBookableDates = exports.troubleshotStartTimesForSelectedDate = exports.getGroupedTroubleshotStartTimes = exports.getTroubleshotStartTimes = exports.getBufferTimeRangesWithDescriptions = exports.getStandardLengthBusyTimeRangesWithDescriptions = exports.getDayLongBusyTimeRangesWithDescriptions = exports.getBusyTimeRangesWithDescriptions = exports.getPastTroubleshotStartTimes = exports.getFuturePossibleStartTimes = exports.getConfiguredPossibleStartTimes = exports.getConfiguredAvailableTimeRanges = exports.isTroubleshootingSelector = exports.canTroubleshootSelector = exports.userLoggedInToValidPortal = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _reselect = require("reselect");

var _get = _interopRequireDefault(require("transmute/get"));

var _pipe = _interopRequireDefault(require("transmute/pipe"));

var _immutable = require("immutable");

var _analytics = require("MeetingsLib/utils/analytics");

var _utils = require("MeetingsBase/utils/utils");

var _RESTParamSelectors = require("MeetingsLib/selectors/RESTParamSelectors");

var _troubleshootStartTimes = require("MeetingsLib/utils/troubleshootStartTimes");

var _TimeRangeListUtils = require("MeetingsBase/utils/TimeRangeListUtils");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _enums = require("MeetingsLib/constants/enums");

var _dates = require("MeetingsBase/constants/dates");

var _AvailabilityMilliseconds = _interopRequireDefault(require("MeetingsBase/models/AvailabilityMilliseconds"));

var _TimeRangeWithDescription = _interopRequireDefault(require("MeetingsLib/models/TimeRangeWithDescription"));

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

var createSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _immutable.is);
var isTroubleshooting = (0, _get.default)('troubleshooting');
var shouldAllowTroubleshootMode = (0, _get.default)('allowTroubleshootMode');

var userLoggedInToValidPortal = function userLoggedInToValidPortal(state) {
  var portalIdFromUserProfile = (0, _get.default)('portalId', state);
  var portalIdFromLoginCookie = (0, _analytics.getHubSpotHubId)();
  return portalIdFromUserProfile && portalIdFromLoginCookie && "" + portalIdFromUserProfile === portalIdFromLoginCookie;
};

exports.userLoggedInToValidPortal = userLoggedInToValidPortal;
var canTroubleshootSelector = createSelector([_RESTParamSelectors.getEmbedded, _BookInfoSelectors.getOffline, shouldAllowTroubleshootMode, userLoggedInToValidPortal], function (embedded, offline, allowTroubleshootMode, loggedIn) {
  return !embedded && !offline && allowTroubleshootMode && loggedIn || false;
});
exports.canTroubleshootSelector = canTroubleshootSelector;
var isTroubleshootingSelector = createSelector([isTroubleshooting, canTroubleshootSelector], function (troubleshooting, canTroubleshoot) {
  return troubleshooting && canTroubleshoot;
});
exports.isTroubleshootingSelector = isTroubleshootingSelector;
var getConfiguredAvailableTimeRanges = createSelector([isTroubleshootingSelector, _BookInfoSelectors.getCustomParams, _RESTParamSelectors.getCurrentTime], function (troubleshooting, customParams, currentTime) {
  if (!troubleshooting) {
    return (0, _immutable.List)();
  }

  return (0, _utils.getConfiguredAvailableTimeRanges)(_AvailabilityMilliseconds.default.fromAvailability(customParams.availability), customParams.weeksToAdvertise, customParams.customAvailabilityStartDate, customParams.customAvailabilityEndDate, customParams.timezone, currentTime);
});
exports.getConfiguredAvailableTimeRanges = getConfiguredAvailableTimeRanges;
var getConfiguredPossibleStartTimes = createSelector([_BookInfoSelectors.getStartTimeIntervalMilliseconds, getConfiguredAvailableTimeRanges, _BookInfoSelectors.getEvent], function (startTimeIntervalMilliseconds, configuredAvailableTimeRanges, event) {
  return (0, _TimeRangeListUtils.getFlexibleIntervalStartTimes)(configuredAvailableTimeRanges, event.duration, startTimeIntervalMilliseconds);
});
exports.getConfiguredPossibleStartTimes = getConfiguredPossibleStartTimes;
var getFuturePossibleStartTimes = createSelector([getConfiguredPossibleStartTimes, _RESTParamSelectors.getCurrentTime], function (allPossibleStartTimes, currentTime) {
  return allPossibleStartTimes.filter(function (time) {
    return time >= currentTime;
  });
});
exports.getFuturePossibleStartTimes = getFuturePossibleStartTimes;
var getPastTroubleshotStartTimes = createSelector([getConfiguredPossibleStartTimes, _RESTParamSelectors.getCurrentTime], function (allPossibleStartTimes, currentTime) {
  return (0, _troubleshootStartTimes.troubleshootPastStartTimes)(allPossibleStartTimes, currentTime);
});
/**
 * @param {boolean} isTroubleshootingSelector Whether user is troubleshooting
 * @param {BookInfo} bookInfo Busy times data
 * @returns {List} All users' busy time ranges, with descriptions including
 * which user they belong to, and whether they're all-day or standard length
 * Note: if user is not troubleshooting, don't calculate anything
 */

exports.getPastTroubleshotStartTimes = getPastTroubleshotStartTimes;
var getBusyTimeRangesWithDescriptions = createSelector([isTroubleshootingSelector, _BookInfoSelectors.getBookInfo], function (troubleshooting, bookInfo) {
  if (!troubleshooting) {
    return (0, _immutable.List)();
  }

  var allUsersAndBusyTimes = bookInfo.allUsersBusyTimes;
  return allUsersAndBusyTimes.map(function (userAndBusyTimes) {
    return userAndBusyTimes.busyTimes.map(function (busyTimeRange) {
      var isDayLong = busyTimeRange.duration() >= _dates.ONE_DAY;

      return new _TimeRangeWithDescription.default({
        timeRange: _TimeRange.default.from(busyTimeRange),
        ownerFirstName: userAndBusyTimes.firstName,
        ownerLastName: userAndBusyTimes.lastName,
        ownerEmail: userAndBusyTimes.email,
        type: isDayLong ? _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT : _enums.UNAVAILABLE_REASONS.EVENT
      });
    });
  }).flatten(true);
}); // filters events longer than a day

exports.getBusyTimeRangesWithDescriptions = getBusyTimeRangesWithDescriptions;
var getDayLongBusyTimeRangesWithDescriptions = createSelector([getBusyTimeRangesWithDescriptions], function (busyTimeRangesWithDescriptions) {
  return busyTimeRangesWithDescriptions.filter(function (rangeWithDescriptions) {
    return rangeWithDescriptions.type === _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT;
  });
}); // filters events shorter than a day

exports.getDayLongBusyTimeRangesWithDescriptions = getDayLongBusyTimeRangesWithDescriptions;
var getStandardLengthBusyTimeRangesWithDescriptions = createSelector([getBusyTimeRangesWithDescriptions], function (busyTimeRangesWithDescriptions) {
  return busyTimeRangesWithDescriptions.filter(function (rangeWithDescriptions) {
    return rangeWithDescriptions.type === _enums.UNAVAILABLE_REASONS.EVENT;
  });
});
/**
 * @param {boolean} isTroubleshootingSelector Whether user can troubleshoot
 * @param {BookInfo} bookInfo Busy times data
 * @returns {List} Buffer time ranges around all users' calendar events, with
 * descriptions including which user they belong to, and the timestamp of the
 * event they are buffering
 * Note: if user is not troubleshooting, don't calculate anything
 */

exports.getStandardLengthBusyTimeRangesWithDescriptions = getStandardLengthBusyTimeRangesWithDescriptions;
var getBufferTimeRangesWithDescriptions = createSelector([isTroubleshootingSelector, _BookInfoSelectors.getBookInfo], function (troubleshooting, bookInfo) {
  if (!troubleshooting) {
    return (0, _immutable.List)();
  }

  var allUsersAndBusyTimes = bookInfo.allUsersBusyTimes,
      bufferTime = bookInfo.customParams.meetingBufferTime;
  return allUsersAndBusyTimes.map(function (userAndBusyTimes) {
    return userAndBusyTimes.busyTimes.map(function (busyTimeRange) {
      // turn each busy time range into 2 buffer time ranges, one before, one after
      var bufferTimeRanges = (0, _TimeRangeListUtils.getBufferTimeRanges)(busyTimeRange, bufferTime);
      return bufferTimeRanges.map(function (bufferTimeRange) {
        return new _TimeRangeWithDescription.default({
          relatedEventStartTime: busyTimeRange.start,
          timeRange: _TimeRange.default.from(bufferTimeRange),
          ownerFirstName: userAndBusyTimes.firstName,
          ownerLastName: userAndBusyTimes.lastName,
          ownerEmail: userAndBusyTimes.email,
          type: _enums.UNAVAILABLE_REASONS.BUFFER
        });
      });
    });
  }).flatten(2);
});
exports.getBufferTimeRangesWithDescriptions = getBufferTimeRangesWithDescriptions;
var getTroubleshotStartTimes = createSelector([isTroubleshootingSelector, getFuturePossibleStartTimes, getPastTroubleshotStartTimes, _BookInfoSelectors.getAvailableStartTimes, _BookInfoSelectors.getCustomParams, _BookInfoSelectors.getMeetingLength, getDayLongBusyTimeRangesWithDescriptions, getStandardLengthBusyTimeRangesWithDescriptions, getBufferTimeRangesWithDescriptions, _RESTParamSelectors.getCurrentTime], function (troubleshooting, futurePossibleStartTimes, troubleshotPastStartTimes, availableStartTimes, customParams, duration, dayLongBusyTimeRangesWithDescriptions, standardBusyTimeRangesWithDescriptions, bufferTimeRangesWithDescriptions, currentTime) {
  if (!troubleshooting) {
    return (0, _immutable.List)();
  }

  var minimumNoticeTime = customParams.minimumNoticeTime;
  var troubleshotStartTimes = (0, _troubleshootStartTimes.troubleshootAvailableTimes)(futurePossibleStartTimes, availableStartTimes);
  var troubleshoot = (0, _pipe.default)((0, _troubleshootStartTimes.troubleshootMinimumNoticeTime)(minimumNoticeTime, currentTime), (0, _troubleshootStartTimes.troubleshootTimeRanges)(duration, dayLongBusyTimeRangesWithDescriptions), (0, _troubleshootStartTimes.troubleshootTimeRanges)(duration, standardBusyTimeRangesWithDescriptions), (0, _troubleshootStartTimes.troubleshootTimeRanges)(duration, bufferTimeRangesWithDescriptions), _troubleshootStartTimes.removeTimesWithoutReasons);
  troubleshotStartTimes = troubleshoot(troubleshotStartTimes);
  return troubleshotPastStartTimes.concat(troubleshotStartTimes).sort(function (timeA, timeB) {
    return timeA.time - timeB.time;
  });
});
exports.getTroubleshotStartTimes = getTroubleshotStartTimes;
var getGroupedTroubleshotStartTimes = createSelector([getTroubleshotStartTimes, _BookInfoSelectors.getUserTimezone], function (troubleshotStartTimes, userTimezone) {
  return troubleshotStartTimes.groupBy(function (troubleshotTime) {
    return _I18n.default.moment(troubleshotTime.time).tz(userTimezone).format('YYYY-MM-DD');
  });
}); // Date selectors

exports.getGroupedTroubleshotStartTimes = getGroupedTroubleshotStartTimes;
var troubleshotStartTimesForSelectedDate = createSelector([getGroupedTroubleshotStartTimes, _BookInfoSelectors.getEvent], function (groupedTroubleshotStartTimes, event) {
  return groupedTroubleshotStartTimes.get(event.dateString) || (0, _immutable.List)();
});
exports.troubleshotStartTimesForSelectedDate = troubleshotStartTimesForSelectedDate;
var getConfiguredBookableDates = createSelector([isTroubleshootingSelector, _BookInfoSelectors.getCustomParams, _RESTParamSelectors.getCurrentTime], function (troubleshooting, customParams, currentTime) {
  if (!troubleshooting) {
    return (0, _immutable.List)();
  }

  var weeksToAdvertise = customParams.weeksToAdvertise,
      customAvailabilityStartDate = customParams.customAvailabilityStartDate,
      customAvailabilityEndDate = customParams.customAvailabilityEndDate;
  return (0, _utils.getBookableDays)(weeksToAdvertise, customAvailabilityStartDate, customAvailabilityEndDate, currentTime).map(function (startDayTimestamp) {
    return _I18n.default.moment.utc(startDayTimestamp).format('YYYY-MM-DD');
  });
});
exports.getConfiguredBookableDates = getConfiguredBookableDates;
var getConfiguredAvailabilityByDate = createSelector([getConfiguredPossibleStartTimes, _BookInfoSelectors.getUserTimezone], function (configuredPossibleStartTimes, userTimezone) {
  return configuredPossibleStartTimes.groupBy(function (startTime) {
    return _I18n.default.moment(startTime).tz(userTimezone).format('YYYY-MM-DD');
  });
});
exports.getConfiguredAvailabilityByDate = getConfiguredAvailabilityByDate;
var getMinimumNoticeTimeBusyDays = createSelector([_BookInfoSelectors.getCustomParams, _RESTParamSelectors.getCurrentTime], function (customParams, currentTime) {
  var minimumNoticeTime = customParams.minimumNoticeTime;

  if (minimumNoticeTime < _dates.ONE_DAY) {
    return (0, _immutable.List)();
  }

  var numberOfDays = Math.floor(minimumNoticeTime / _dates.ONE_DAY);
  var listOfDays = (0, _utils.getListOfDays)(_I18n.default.moment(currentTime), numberOfDays);
  return listOfDays.map(function (timestamp) {
    return _I18n.default.moment(timestamp).format('YYYY-MM-DD');
  });
});
exports.getMinimumNoticeTimeBusyDays = getMinimumNoticeTimeBusyDays;